module.exports = __webpack_public_path__ + "static/media/hrdlička7.a11c5bf8.jpg";